/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Civil_Engineering20Inputs */

const en__field_enum_tuda_civil_engineering20 = /** @type {(inputs: _Field_Enum_Tuda_Civil_Engineering20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Civil & Environmental Engineering`)
};

const de__field_enum_tuda_civil_engineering20 = /** @type {(inputs: _Field_Enum_Tuda_Civil_Engineering20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bau- & Umweltingenierwissenschaften`)
};

/**
* | output |
* | --- |
* | "Civil & Environmental Engineering" |
*
* @param {_Field_Enum_Tuda_Civil_Engineering20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_civil_engineering20 = /** @type {((inputs?: _Field_Enum_Tuda_Civil_Engineering20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Civil_Engineering20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_civil_engineering20(inputs)
	return de__field_enum_tuda_civil_engineering20(inputs)
});
export { _field_enum_tuda_civil_engineering20 as "_field_enum_TUDA_CIVIL_ENGINEERING" }